module.exports = __webpack_public_path__ + "img/two_single_dog.503a2e22.png";